import { render } from "./FormCarComponent.vue?vue&type=template&id=54918434"
import script from "./FormCarComponent.vue?vue&type=script&lang=js"
export * from "./FormCarComponent.vue?vue&type=script&lang=js"

import "./FormCarComponent.vue?vue&type=style&index=0&id=54918434&lang=css"

import exportComponent from "/home/ubuntu/gestionale-partner-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__